import { render, staticRenderFns } from "./ReInputRailway.vue?vue&type=template&id=38bc7e01&scoped=true"
import script from "./ReInputRailway.vue?vue&type=script&lang=js"
export * from "./ReInputRailway.vue?vue&type=script&lang=js"
import style0 from "./ReInputRailway.vue?vue&type=style&index=0&id=38bc7e01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc7e01",
  null
  
)

export default component.exports